import request from '@/utils/request'


export function getTypes(isNotify) {
  return request({
    url: `/api/getTypeOfBusinesses`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}

export function getTypeForm(isNotify) {
  return request({
    url: `/api/getTypeOfBusinessForm`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}

export function saveTypes(params, isNotify) {
  return request({
    url: `/api/saveTypeOfBusinesses`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}

export function uploadForms(params, isNotify) {
  return request({
    url: `/api/uploadTypeOfBusiness?desc=`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'multipart/form-data' },
    data: params,
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}